export default [
  'Agriculture and Agri-food Canada',
  'Atlantic Canada Opportunities Agency',
  'Association of Consulting Engineers of Canada',
  'Bell Canada',
  'Canada Revenue Agency',
  'Canada Student Loans Program',
  'Canadian Association of Defence and Security Industries (CADSI)',
  'Canadian Broadcasting Corporation',
  'Canadian Border Services Agency',
  'Canada Business Network',
  'Canadian Foundation for the Americas',
  'Canadian Heritage',
  'Canadian Housing and Renewal Association',
  'Canadian Space Agency',
  'Canadian Steel Producers Association',
  'Carleton University',
  'CMHC (Canada Mortgage and Housing Corporation)',
  'CIDA (Canadian International Development Agency)',
  'City of Ottawa',
  'Corporations Canada',
  'Correctional Service of Canada',
  'CRTC',
  'Export Development Canada',
  'Elections Canada',
  'Employment and Social Development Canada',
  'Environment Canada',
  'Financial Consumer Agency of Canada',
  'Farm Credit Canada',
  'FedNor',
  'Finance Canada',
  'Global Affairs Canada',
  'Health Canada',
  'Immigration, Refugees and Citizenship Canada',
  'Innovation, Science and Economic Development Canada / Industry Canada',
  'Indigenous and Northern Affairs Canada',
  'Library and Archives Canada',
  'Royal Canadian Mint',
  'Métis Nation of Ontario',
  'Montfort Hospital',
  'National Defence / Canadian Forces',
  'Natural Resources Canada',
  'NSERC (Natural Sciences and Engineering Research Council)',
  'Ontario Government (multiple departments/agencies)',
  'Office of the Privacy Commissioner of Canada',
  'Ottawa Public Health',
  'Ottawa Public Library',
  'Office of the Superintendent of Financial Institutions',
  'Office of the Parliamentary Budget Officer',
  'Canadian Parents for French',
  'Parks Canada',
  'Passport Canada',
  'Public Health Agency of Canada',
  'Public Services and Procurement Canada',
  'Public Sector Integrity Commissioner',
  'Public Safety Canada',
  'Service Canada',
  'Sports Canada',
  'Standards Council of Canada',
  'Translation Bureau',
  'Transport Canada',
  'Treasury Board Secretariat',
  'United Nations',
  'University of Ottawa',
  'Veterans Affairs Canada'
];
